import React , {useState} from 'react';
import './HeroSearch.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';


const HeroSearch = () => {

    let navigate = useNavigate();


    const [error , setError ] = useState('');

    const [searchTerm , setSearchTerm ] = useState('');

    const searchFor = () => {

            if (searchTerm === '') {
                setError(' يرجى ادخال مكان البحث ')
            }
     

            if (searchTerm !== '') {
                navigate(`/package-search/${searchTerm}`);
            }
     

    }


  return (
    <div className='hero_explore_slider' >

<div className="explore_single_div explroe_hero_1" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"  style={{ minHeight: '90vh' }}  >

<div className="content_top_explore">
<h1 className="heroarea_subheadline">  نروح مشوار جديد ؟ </h1>
<div className="underline_line_thick"></div>
</div>



<div className="mt-3 explore_content_area ">

<div className="text-center hero_sliding_div ">

<div className='' >
<h1 className="heroarea_headline" > جرب تحجز افضل تجربة سياحية </h1>

    <div className="searching_main_div flex-row mt-3">


    <div className='items_inside' >
    {error && (
                            <>
                            <h1 className="mb-1 error_headline"> {error} </h1>
                            </>
                        )}
    
    <div className="where_search_div mt-2">
                <span className="login_label_form"> أين ؟ </span>
                <select  id="" className="login_input_form" value={searchTerm} onChange={(e) => {
        const selectedWhere = e.target.value;
        setSearchTerm(selectedWhere);
      }}  >

                    <option value=""> ... </option>
                    <option value="جازان"> جازان </option>
                    <option value="جدة"> جدة </option>
                    <option value="الرياض"> الرياض </option>
                    <option value="الدرعية"> الدرعية  </option>

                </select>
        </div>

        <div className="confirm_search_div">
            <button className="btn_search b-radius bg_purple w-100" onClick={() => searchFor() } > أبحث الان </button>
        </div>
    </div>
     

    </div>

</div>



</div>



</div>
</div>

    </div>
  )
}

export default HeroSearch